import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  collegeClassList: [],
}

export const getters = {}

export const mutations = {
  CACHE_COLLEGECLASS_LIST(state, newList) {
    state.collegeClassList = newList
  },
}

export const actions = {
  // College List Service
  fetchCollegeClassList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/college-class/?${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_COLLEGECLASS_LIST', list)
        return list
      })
  },

  // Add College Service
  addCollegeClassData({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/college-class`, Data)
      .then((response) => {
        const resp = response.data
        return resp
      })
  },

  // Update College Service
  updateCollegeClassData({ commit, state, rootState }, { Data }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/college-class/${Data.id}`,
        Data
      )
      .then((response) => {
        const resp = response.data
        return resp
      })
  },

  deleteCollegeClassData({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/college-class/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
